import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { GET_CITIES } from "../graphql/Queries/CityQuery";
import { useMutation, useQuery } from "@apollo/client";
import { DELETE_CITY } from "../graphql/Mutations/CityMutation";
import i18next from "i18next";

export const Cities = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { data } = useQuery(GET_CITIES, {
    fetchPolicy: "no-cache",
  });
  const [removeCity] = useMutation(DELETE_CITY);

  useEffect(() => {
    if (data) {
      setItems(data.cities);
    }
  }, [data]);

  const remove = (id) => {
    removeCity({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteCity);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Города"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                  {
                    key: "country",
                    label: "Страна",
                    callback: (data) => {
                      const country = data.name.find((n) => {
                        return n.lang === i18next.language;
                      });
                      return country.value;
                    },
                    sort: "country.name",
                  },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
